import clsx from 'clsx'
import { isSameDay } from 'date-fns'

import { formatDate } from '@/utils/format-date'

import styles from './SchoolBreak.module.scss'
import type { SchoolBreakEvent as SchoolBreakEventType } from '../constants/timetable-events'

export type SchoolBreakEventProps = SchoolBreakEventType

const SchoolBreakEvent = (props: SchoolBreakEventProps) => {
  const isOneDayEvent = isSameDay(props.startDate, props.endDate)

  const timeText = isOneDayEvent
    ? formatDate(props.startDate)
    : `${formatDate(props.startDate)} — ${formatDate(props.endDate)}`

  return (
    <div className={clsx(styles.event)}>
      <div className={styles.eventHeader}>
        <span className={styles.eventTitle}>{props.name}</span>
      </div>

      <span className={styles.eventText}>{timeText}</span>
    </div>
  )
}
export default SchoolBreakEvent
